import React from 'react';

class Table extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: []
        }
    }

    toggleExpanded(id) {
        if (this.state.expanded.indexOf(id) === -1) {
            this.setState({
                expanded: [id, ...this.state.expanded]
            })
        } else {
            this.setState({
                expanded: this.state.expanded.filter(e => e !== id)
            })
        }

        console.log(id)
    }

    render() {
        const table = this.props.table;
        return (
            <div>
                <table className="rounded w-full table-auto break-all bg-gray-100 text-gray-700">
                    <thead>
                    <tr>
                        <td className="w-auto text-center border px-4 py-2">
                        </td>
                        <td className="w-2/5 border px-4 py-2 font-medium">
                            Name
                        </td>
                        <td className="w-1/5 border px-4 py-2 font-medium text-right">Duration (s)</td>
                        <td className="w-2/5 border px-4 py-2 font-medium text-left">Details</td>
                    </tr>
                    </thead>
                    <tbody>
                    {table.map((row, i) => <Row
                        data={row}
                        expanded={this.state.expanded}
                        onClick={id => this.toggleExpanded(id)}
                        expandAll={this.props.expandAll }/>
                    )}
                    </tbody>
                </table>
            </div>
        );
    }
}

function Row({data, level = 0, parentId = null, onClick, expanded, expandAll}) {
    const isExpanded = expanded.indexOf(data.data.id) !== -1;
    const hasChildren = data.children.length > 0;
    return (
        <React.Fragment>
            <tr className={`bg-yellow-${Math.min(5, level)}00 ${hasChildren ? 'cursor-pointer hover:bg-purple-200': null}`}
                onClick={() => hasChildren ? onClick(data.data.id) : false}>
                <td className="w-auto text-center border px-4 py-2">
                    {data.children.length > 0
                        ? <span className="float-right"><ExpandIcon isExpanded={expandAll || isExpanded}/></span>
                        : null}
                </td>
                <td className={`w-2/5 border px-4 py-2`}
                    style={{paddingLeft: `${12 + 8 * level}px`}}>
                    {data.data.name} {data.children.length > 0 ? <span className="text-gray-500">({data.children.length})</span> : null}
                </td>
                <td className="w-1/5 border px-4 py-2 text-right">{data.data.duration}</td>
                <td className="w-2/5 border px-4 py-2 text-left text-sm">
                    <ul>{data.data.details.map(item => <li><strong
                        className={'text-gray-800'}>{item.key}</strong>: <span
                        className={''}> {item.value}</span></li>)}</ul>
                </td>
            </tr>
            {(expandAll || isExpanded) && data.children.map((row, i) =>
                <Row
                    data={row}
                    level={level + 2}
                    parentId={data.data.id}
                    expanded={expanded}
                    onClick={onClick}
                    expandAll={expandAll}
                />
            )}
        </React.Fragment>
    )
}

function ExpandIcon({isExpanded}) {
    if (isExpanded) {
        return (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"></path>
            </svg>
        )
    } else {
        return (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"></path>
            </svg>
        )
    }
}

export default Table;
